// src/App.js - Add ApprovalProvider for Caching
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { NotificationProvider } from "./contexts/NotificationContext";
import ErrorBoundary from "./components/ErrorBoundary";
import ToastContainer from "./components/ToastContainer";
import Layout from "./components/Layout";
import ProtectedRoute, { ApprovalProvider } from "./components/ProtectedRoute"; // Import both

import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import DashboardPage from "./pages/DashboardPage";
import CreateSitePage from "./pages/CreateSitePage";
import BulkCreatePage from "./pages/BulkCreatePage";
import SettingsPage from "./pages/SettingsPage";
import PendingApprovalPage from "./pages/PendingApprovalPage";
import EditSitePage from "./pages/EditSitePage";

function App() {
  return (
    <ErrorBoundary level="app">
      <NotificationProvider>
        <ApprovalProvider> {/* Add ApprovalProvider */}
          <Router>
            <ErrorBoundary level="layout">
              <Layout>
                <ErrorBoundary level="page">
                  <Routes>
                    <Route path="/" element={<Navigate to="/login" />} />
                    
                    {/* PUBLIC ROUTES - No protection needed */}
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/signup" element={<SignupPage />} />
                    <Route path="/pending-approval" element={<PendingApprovalPage />} />
                    
                    {/* PROTECTED ROUTES - Require authentication AND approval */}
                    <Route 
                      path="/dashboard" 
                      element={
                        <ProtectedRoute>
                          <ErrorBoundary level="page">
                            <DashboardPage />
                          </ErrorBoundary>
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/create-site" 
                      element={
                        <ProtectedRoute>
                          <ErrorBoundary level="page">
                            <CreateSitePage />
                          </ErrorBoundary>
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/settings" 
                      element={
                        <ProtectedRoute>
                          <ErrorBoundary level="page">
                            <SettingsPage />
                          </ErrorBoundary>
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/edit-site/:id" 
                      element={
                        <ProtectedRoute>
                          <ErrorBoundary level="page">
                            <EditSitePage />
                          </ErrorBoundary>
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/bulk-create" 
                      element={
                        <ProtectedRoute>
                          <ErrorBoundary level="page">
                            <BulkCreatePage />
                          </ErrorBoundary>
                        </ProtectedRoute>
                      } 
                    />
                  </Routes>
                </ErrorBoundary>
              </Layout>
            </ErrorBoundary>
            
            {/* Toast Notifications - Global, outside error boundaries */}
            <ToastContainer />
          </Router>
        </ApprovalProvider> {/* Close ApprovalProvider */}
      </NotificationProvider>
    </ErrorBoundary>
  );
}

export default App;